export class OpImportPluginParam {
    public defaultValue: any
    public idDataType: number
    public isInputParam: boolean
    public isVisible: boolean
    public value: any

    constructor(opObj: any) {
        if (opObj != null) {
            this.defaultValue = opObj.DefaultValue
            this.idDataType = opObj.IdDataType
            this.isInputParam = opObj.IsInputParam
            this.isVisible = opObj.IsVisible
            this.value = opObj.Value
        }
    }

    toJSON() {
        return {
            DefaultValue: this.defaultValue,
            IdDataType: this.idDataType,
            IsInputParam: this.isInputParam,
            IsVisible: this.isVisible,
            Value: this.value
        }
    }
}